import { render, staticRenderFns } from "./TableEditor.vue?vue&type=template&id=0a711b4a&scoped=true"
import script from "./TableEditor.vue?vue&type=script&lang=js"
export * from "./TableEditor.vue?vue&type=script&lang=js"
import style0 from "./TableEditor.vue?vue&type=style&index=0&id=0a711b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a711b4a",
  null
  
)

export default component.exports